// extracted by mini-css-extract-plugin
export var modal = "modal-module--modal--3RZ6a";
export var inner = "modal-module--inner--2UQKi";
export var modalContent = "modal-module--modalContent--2yiFC";
export var video = "modal-module--video--xm1j2";
export var modalClose = "modal-module--modalClose--2Kpd7";
export var active = "modal-module--active--elIzq";
export var modalInnerPop = "modal-module--modalInnerPop--1hqgr";
export var close = "modal-module--close--1J6Wi";